var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"redacted",style:({minWidth: _vm.length * _vm.scale + 'rem'}),attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.reveal=!_vm.reveal}}},[_vm._v(" "+_vm._s(_vm.reveal ? _vm.secret : _vm.output)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }